import {NgModule, inject, provideAppInitializer} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from "./core/core.module";
import {SharedModule} from "./shared/shared.module";
import {FormsModule} from "@angular/forms";
import {UcetniJednotkaDataModule} from "./ucetni-jednotka-data/ucetni-jednotka-data.module";
import {IdentityServerDataModule} from "./identity-server-data/identity-server-data.module";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UserDataModule} from './user-data/user-data.module';
import {RoleDataModule} from './role-data/role-data.module';
import {UserRoleDataModule} from './user-role-data/user-role-data.module';
import {CroRegistrationDataModule} from './cro-registration-data/cro-registration-data.module';
import {EnvironmentService} from './core/environment/environment.service';
import {PrenosUcetniJednotkaDataModule} from './prenos-ucetni-jednotka-data/prenos-ucetni-jednotka-data.module';
import {NastaveniUcetniJednotkaDataModule} from './nastaveni-ucetni-jednotka-data/nastaveni-ucetni-jendotka-data.module';
import {DefiniceVykazuDataModule} from "./definice-vykazu-data/definice-vykazu-data.module";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {CzechMomentDateAdapter, CZECH_DATE_FORMATS} from "./core/localization/czech-moment-date-adapter";


export function initConfig(appConfigService: EnvironmentService) {
  return () => appConfigService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    FormsModule,
    IdentityServerDataModule,
    BrowserAnimationsModule,
    UcetniJednotkaDataModule,
    UserDataModule,
    UserRoleDataModule,
    RoleDataModule,
    CroRegistrationDataModule,
    PrenosUcetniJednotkaDataModule,
    NastaveniUcetniJednotkaDataModule,
    DefiniceVykazuDataModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = (initConfig)(inject(EnvironmentService));
      return initializerFn();
    }),
    { provide: DateAdapter, useClass: CzechMomentDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'cs-CZ'},
    { provide: MAT_DATE_FORMATS, useValue: CZECH_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
